/*--------------------------------------------------------------
# Custom scripts for In Page Navigation block
--------------------------------------------------------------*/
document.addEventListener('DOMContentLoaded', function() {
    // Referencia al select del DOM
    var selectElement = document.getElementById('anchor-links');

    if (selectElement) {
        selectElement.onchange = function() {
            updateSelectClass(this);
        };
    }

    function updateSelectClass(select) {
        // Cambiar la página basado en el valor seleccionado
        window.location.href = select.value;

        // Actualizar la clase basado en si la primera opción está seleccionada o no
        if (select.selectedIndex === 0) {
            select.classList.add("no-selection");
            select.classList.remove("selection-done");
        } else {
            select.classList.remove("no-selection");
            select.classList.add("selection-done");
        }
    }

    function updateActiveLink() {
        const links = document.querySelectorAll('.tab-row--in-page-nav .tab-row__item');

        let foundActive = false;

        links.forEach(link => {
            let targetId = link.getAttribute('href');
            if (targetId) {
                // Escapar ID si comienza con un número
                targetId = targetId.replace(/^#(\d)/, '#\\3$1 ');
                const targetElement = document.querySelector(targetId);
                if (targetElement) {
                    const distanceToTop = targetElement.getBoundingClientRect().top;
                    if (distanceToTop <= 200 && distanceToTop >= -300 && !foundActive) {
                        link.classList.add('active-item');
                        foundActive = true;
                    } else {
                        link.classList.remove('active-item');
                    }
                }
            }
        });

        if (!foundActive) {
            links.forEach(link => link.classList.remove('active-item'));
        }
    }

    window.addEventListener('scroll', updateActiveLink);
    updateActiveLink();
});

